module.exports = __webpack_public_path__ + "static/media/group1.e4c867a2.png";